import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalChiTiet } from "./ModalChiTiet";

export const BtnChiTiet = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a href={() => false} className="blue btn-link" onClick={handleShow}>
        {item.TenSanPham}
      </a>
      {show && (
        <ModalChiTiet
          show={show}
          onHide={handleClose}
          Id={item.Id}
          item={item}
        />
      )}
    </>
  );
};
